import { Box, Grid, Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useResponsive from "../../hooks/useResponsive";
import { InfoBox } from "../designUi";
import { UserIconLarge } from "../UIElements/svg-icons";

const UsersTopStats = () => {
  const theme = useTheme();
  const isMedium = useResponsive("down", "md", "xl");
  const isSmall = useResponsive("down", "sm", "xl");

  return (
    <>
      <Grid container>
        <Grid
          item
          xs={isSmall ? 12 : 12}
          sx={{ paddingX: isSmall ? 0 : 2, paddingY: 2 }}
        >
          <InfoBox title={"Users"} value={0} icon={<UserIconLarge />} />
        </Grid>
        {/* <Grid
          item
          xs={isSmall ? 12 : 6}
          sx={{ paddingX: isSmall ? 0 : 2, paddingY: 2 }}
        >
          <InfoBox title={"Permission"} value={0} icon={<UserIconLarge />} />
        </Grid>{" "} */}
      </Grid>
    </>
  );
};

export default UsersTopStats;
